import angular from 'angular';

import { accessLevels } from '../constants';

import OnboardingCtrl from './OnboardingCtrl';
import indexUrl from './index.html';
import orgSetupOnboarding from './components/orgSetupOnboarding';
import onboardingChecklist from './components/onboardingChecklist';

const onboardingModule = angular.module('sling.onboarding', []);

onboardingModule.config(($stateProvider) => {
  $stateProvider.state('orgSetupOnboarding', {
    template: '<org-setup-onboarding></org-setup-onboarding>',
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
    },
    params: {
      redirectTo: null,
      redirectParams: null,
    },
    data: {
      title: 'Set up Sling',
      bodyClass: 'org-setup-onboarding',
    },
    onEnter($rootScope) {
      $rootScope.checkedOnboarding = true;
    },
  });
  $stateProvider.state('onboarding', {
    templateUrl: indexUrl,
    controller: OnboardingCtrl,
    controllerAs: 'ctrl',
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
    },
    data: {
      title: 'Set up Sling',
      access: accessLevels.user,
      bodyClass: 'first-onboarding',
    },
    onEnter($rootScope) {
      $rootScope.checkedOnboarding = true;
    },
  });
});

onboardingModule.component('orgSetupOnboarding', orgSetupOnboarding);
onboardingModule.component('onboardingChecklist', onboardingChecklist);

export default onboardingModule.name;
